import { CustomTagProps } from 'rc-select/lib/BaseSelect';
import { Tag } from 'antd';

export const ILSTagEmpty = (props: CustomTagProps) => {
  return <Tag style={{ display: 'none' }} />;
};
